module.exports = __webpack_public_path__ + "static/media/achesoothe-4.fcf54d17.png";